import { render, staticRenderFns } from "./UpdateCustomerCashback.vue?vue&type=template&id=da405c28&scoped=true&"
import script from "./UpdateCustomerCashback.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerCashback.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerCashback.vue?vue&type=style&index=0&id=da405c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da405c28",
  null
  
)

export default component.exports